export default __webpack_public_path__ + "./images/tr.d2777f6e.png";